import { DrawerDiaLogTitle } from '../drawer-dialog';
import { Button } from '../ui/button';
import { ViewFourIcon, ViewOneIcon, ViewThreeIcon, ViewTwoIcon } from '@/client/assets';
import { TERMS_OF_USE_LINK } from '@/client/confs/app';
import { useAuth } from '@/client/hooks/use-auth';
import { useAppSettingStore } from '@/client/store/app-store';
import confetti from 'canvas-confetti';
import { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';

type OnboardContentProps = {
  onClose: () => void;
};
export const OnboardContent = ({ onClose }: OnboardContentProps) => {
  const { t } = useTranslation();
  const { isAuthed, login } = useAuth();
  const baseToken = useAppSettingStore(state => state.baseToken);
  const handleClick = async (event: MouseEvent<HTMLButtonElement>) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const x = rect.left + rect.width / 2;
    const y = rect.top + rect.height / 2;
    setTimeout(() => {
      onClose();
      if (!isAuthed) login();
    }, 8e2);
    await confetti({
      origin: {
        x: x / window.innerWidth,
        y: y / window.innerHeight,
      },
    });
  };
  return (
    <div className="flex justify-center items-stretch md:overflow-hidden h-full">
      <div className="flex-1 hidden md:p-8 md:flex items-center rounded-4 light:bg-[linear-gradient(0deg,#F3FDF5_0%,#F3FDF5_100%,#FFF)] dark:bg-background/20 ">
        <img src="/img/onboard-bg.png" alt="onboard-bg" className="object-cover align-middle" />
      </div>
      <div className="flex-1 md:p-8 rounded-4 space-y-8 flex flex-col justify-center">
        <div className="space-y-2">
          <div className="bg-[linear-gradient(0deg,#FFF4D7_0%,#FFF4D7_100%)] size-12 text-2xl leading-6 flex items-center justify-center rounded-3">
            👋
          </div>
          <div className="space-y-1 font-semibold">
            <DrawerDiaLogTitle className="text-5 leading-9">{t('welcome-to-promethex')}</DrawerDiaLogTitle>
            <p className="text-sm leading-3.5">{t('start-predicting-start-earning')}</p>
          </div>
        </div>
        <div className="space-y-6">
          <div className="flex gap-2">
            <ViewOneIcon className="size-3.5 flex-shrink-0 fill-current" />
            <div className="space-y-2">
              <h3 className="text-sm font-semibold leading-3.5">{t('explore-questions')}</h3>
              <p className="text-sm leading-4.25 text-foreground/70">
                {t('discover-prediction-topics-you-care-about-like-wil')}
              </p>
            </div>
          </div>
          <div className="flex gap-2">
            <ViewTwoIcon className="size-3.5 flex-shrink-0 fill-current" />
            <div className="space-y-2">
              <h3 className="text-sm font-semibold leading-3.5">
                {t('deposit-token', { token: t(baseToken.translateKey) })}
              </h3>
              <p className="text-sm leading-4.25 text-foreground/70">
                {t('fund-your-own-wallet-to-start-making-predictions')}
              </p>
            </div>
          </div>
          <div className="flex gap-2">
            <ViewThreeIcon className="size-3.5 flex-shrink-0 fill-current" />
            <div className="space-y-2">
              <h3 className="text-sm font-semibold leading-3.5">{t('trade')}</h3>
              <p className="text-sm leading-4.25 text-foreground/70">
                {t('buy-or-sell-outcomes-based-on-your-belief-prices-r')}
              </p>
            </div>
          </div>
          <div className="flex gap-2">
            <ViewFourIcon className="size-3.5 flex-shrink-0 fill-current" />
            <div className="space-y-2">
              <h3 className="text-sm font-semibold leading-3.5">{t('earn')}</h3>
              <p className="text-sm leading-4.25 text-foreground/70">{t('if-your-prediction-is-correct-you-win')}</p>
            </div>
          </div>
        </div>
        <div className="space-y-4">
          <Button
            className="h-auto p-4 font-medium text-5 md:text-xl text-background leading-6 rounded-3 w-full"
            onClick={handleClick}
          >
            {t('onboard-predict-now')}
          </Button>
          <p className="text-center text-xs leading-[normal] text-foreground/40 max-w-[290px] mx-auto">
            {t('by-proceeding-you-confirm-youre-at-least-18-and-ac')}{' '}
            <a
              href={TERMS_OF_USE_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="cursor-pointer hover:underline text-foreground/30"
            >
              {t('accept-our-terms')}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};
